import { useEffect, useRef } from 'react';
import { type InsightsClient } from 'search-insights';

import { useFragmentContext } from '@jsmdg/react-fragment-scripts/fragment';
import { type ProductDetailContext } from '../types/types';

export const useInsightsClient = (): { insightsClient?: InsightsClient } => {
    const insightsClient = useRef<InsightsClient | undefined>(undefined);
    const { algoliaConfig } = useFragmentContext<ProductDetailContext>();

    useEffect(() => {
        if (!algoliaConfig.userToken) return;

        // eslint-disable-next-line global-require,@typescript-eslint/no-unsafe-assignment
        insightsClient.current = require('search-insights');
        if (insightsClient.current) {
            insightsClient.current('init', {
                appId: algoliaConfig.appId,
                apiKey: algoliaConfig.searchKey,
            });

            insightsClient.current('setUserToken', algoliaConfig.userToken);
        }
    }, [algoliaConfig.appId, algoliaConfig.searchKey, algoliaConfig.userToken]);

    return {
        insightsClient: insightsClient.current,
    };
};
